import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Icons } from "../assets/icons/Icons";
import { useAuth } from "../service";

export const Sidebar = () => {
  const [theme, setLocalTheme] = useState(
    localStorage.getItem("theme") || "theme-dark"
  );
  const divRef = useRef(null);

  const { logout } = useAuth();

  useEffect(() => {
    const preventScroll = (event) => {
      event.preventDefault();
    };

    const div = divRef.current;
    if (div) {
      div.addEventListener("wheel", preventScroll, { passive: false });
    }

    return () => {
      if (div) {
        div.removeEventListener("wheel", preventScroll);
      }
    };
  }, []);

  useEffect(() => {
    document.body.className = theme;
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setLocalTheme((prevTheme) =>
      prevTheme === "theme-light" ? "theme-dark" : "theme-light"
    );
  };

  const handleClose = () => {
    const modalCloseButton = document.querySelector("#menu-sidebar .btn-close");
    if (modalCloseButton) {
      modalCloseButton.click();
    }
  };

  const handleLogout = () => {
    logout.mutate();
  };

  const links = [
    {
      title: "Learn Mapex",
      id: 0,
      path: "/mapex",
      icons: (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z"
            fill="#2C2AD1"
          />
          <g clip-path="url(#clip0_56952_661)">
            <path
              d="M10 15.2249V23.728L16.9197 27.7467L10 15.0879"
              fill="white"
            />
            <path
              d="M13.4602 17.4648L19.0288 27.9988L24.5606 17.4648C22.7201 18.4864 20.8797 19.5081 19.0401 20.5297C17.1804 19.5081 15.3199 18.4864 13.4602 17.4648Z"
              fill="white"
            />
            <path
              d="M28 15.0879V23.7465L21.0828 27.7467L28 15.0879Z"
              fill="white"
            />
            <path
              d="M10.1316 13.5813C13.1008 15.2388 16.0701 16.8963 19.0393 18.5546C22.0262 16.8971 25.0131 15.2396 28 13.5813L25.026 12C23.0307 13.1402 21.0354 14.2811 19.0401 15.4213C17.0529 14.2811 15.0664 13.1402 13.0792 12L10.1316 13.5813Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_56952_661">
              <rect
                width="18"
                height="16"
                fill="white"
                transform="translate(10 12)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      title: "Plans",
      id: 0,
      path: "/plans",
      icons: (
        <img
          src="./images/store/sidebar_plan_icon.png"
          alt="dark mode"
          style={{
            height: "38px",
            width: "38px",
          }}
        />
      ),
    },
    {
      title: "Project",
      id: 0,
      path: "/project",
      icons: (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z"
            fill="#2C2AD1"
          />
          <path
            d="M14.6115 26.4167L15.898 20.8552L11.5834 17.1146L17.2834 16.6198L19.5 11.375L21.7167 16.6198L27.4167 17.1146L23.1021 20.8552L24.3886 26.4167L19.5 23.4677L14.6115 26.4167Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      title: "Refferal",
      id: 0,
      path: "/refferal",
      icons: (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z"
            fill="#2C2AD1"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.9985 23.2873C28.8398 21.777 27.5057 20.6828 26.0187 20.844C24.7503 20.9813 23.7483 21.999 23.6131 23.2873C23.6102 23.3157 23.6112 23.3441 23.617 23.3719C23.6239 23.3933 23.6646 23.5182 23.7821 23.563C23.8155 23.5755 23.8463 23.5789 23.8718 23.5784H28.7403C28.8844 23.578 29.0005 23.459 29 23.3127C29 23.3043 29 23.2958 28.9985 23.2873Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.3048 17.4706C26.9805 17.4706 27.5282 18.0269 27.5282 18.7132C27.5282 19.3994 26.9805 19.9557 26.3048 19.9557C25.6292 19.9557 25.0815 19.3994 25.0815 18.7132C25.0815 18.0264 25.6297 17.4706 26.3048 17.4706Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.3048 13.0039L26.9045 13.9663L27.9839 14.244L27.27 15.1188L27.3445 16.2489L26.3019 15.8269L25.2681 16.2489L25.3397 15.1113L24.6258 14.242L25.7125 13.9598L26.3083 13.0019L26.3048 13.0039Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.387 23.2873C15.2283 21.777 13.8942 20.6828 12.4072 20.844C11.1392 20.9813 10.1368 21.9995 10.0016 23.2873C9.99867 23.3157 9.99965 23.3441 10.0055 23.3719C10.0124 23.3933 10.053 23.5182 10.1706 23.563C10.204 23.5755 10.2348 23.5789 10.2603 23.5784H15.1288C15.2729 23.578 15.389 23.459 15.3885 23.3127C15.3885 23.3043 15.3885 23.2958 15.387 23.2873Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.6938 17.4706C13.3695 17.4706 13.9172 18.0269 13.9172 18.7132C13.9172 19.3994 13.3695 19.9557 12.6938 19.9557C12.0182 19.9557 11.4704 19.3994 11.4704 18.7132C11.4704 18.0264 12.0187 17.4706 12.6938 17.4706Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.6938 13.0039L13.293 13.9663L14.3724 14.244L13.6585 15.1188L13.733 16.2489L12.6909 15.8269L11.6566 16.2489L11.7286 15.1113L11.0148 14.242L12.101 13.9598L12.6968 13.0019L12.6938 13.0039Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.2118 25.4694C23.9228 22.7156 21.4907 20.7216 18.7794 21.0152C16.4673 21.2655 14.6404 23.1211 14.3939 25.4694C14.3885 25.5212 14.3905 25.5729 14.4008 25.6237C14.413 25.6625 14.4875 25.8909 14.7016 25.972C14.7619 25.9949 14.8192 26.0009 14.8647 25.9999H23.7405C24.0026 25.9989 24.2148 25.7819 24.2138 25.5157C24.2138 25.5003 24.2133 25.4849 24.2118 25.4694Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.3565 14.865C20.6186 14.865 21.6416 15.9041 21.6416 17.1859C21.6416 18.4678 20.6186 19.5069 19.3565 19.5069C18.0944 19.5069 17.0714 18.4678 17.0714 17.1859C17.0724 15.9041 18.0949 14.8655 19.3565 14.865Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.5089 9.00249L20.2996 10.2724L21.7234 10.6382L20.7817 11.7922L20.8797 13.2831L19.505 12.7272L18.141 13.2831L18.2355 11.7827L17.2939 10.6357L18.7269 10.264L19.5128 9L19.5089 9.00249Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      title: "Community",
      id: 0,
      path: "/community",
      icons: (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19Z"
            fill="#2C2AD1"
          />
          <path
            d="M20.0544 11C16.7409 11 15.5104 13.5603 16.4577 15.7294C16.3395 15.8083 16.1497 16.055 16.1891 16.4885C16.268 17.2767 16.6227 17.465 16.8197 17.5044C16.8986 18.2533 17.373 19.1262 17.6488 19.2444C17.6488 19.7568 17.6416 20.1859 17.6021 20.7391C16.9978 22.3258 13.1354 21.958 12.6391 24.803C12.6173 24.927 12.7457 25.2 13.0012 25.2H25.6947C26.0743 25.2 26.067 24.9197 26.0451 24.7913C25.54 21.958 21.6864 22.3244 21.0821 20.7391C21.0427 20.1465 21.0354 19.7568 21.0354 19.2444C21.3112 19.1262 21.7506 18.2139 21.8294 17.5044C22.0265 17.5044 22.3418 17.2665 22.46 16.4768C22.4994 16.0433 22.3374 15.7689 22.1798 15.7294C22.8104 14.9412 22.6965 11.7123 20.3697 11.7123L20.0544 11ZM15.6637 12.8684C13.169 12.9108 12.0757 14.8959 12.826 16.5936C12.7457 16.633 12.5881 16.8417 12.6275 17.2008C12.7077 17.8402 12.9457 17.9949 13.1062 17.9949C13.1851 18.5934 13.5383 19.2648 13.7368 19.3845C13.7368 19.783 13.7412 19.7714 13.7018 20.2487C13.3778 21.2705 10 21.1946 10 23.7053C10 23.7053 10 24.0789 10.3737 24.0789H12.0669C12.6377 22.4645 14.1894 21.8427 15.36 21.3814C16.0052 21.1274 16.6665 20.8705 16.8664 20.5523C16.8883 20.2049 16.9 19.91 16.9015 19.5831C16.5468 19.1773 16.2826 18.5452 16.1541 18.0066C15.8505 17.7818 15.5221 17.3497 15.4418 16.5469C15.4067 16.1659 15.487 15.8491 15.6169 15.601C15.3206 14.6799 15.3396 13.718 15.6637 12.8684ZM24.2 12.8684C23.8424 12.8684 23.4205 12.8976 23.0206 12.9618C23.3198 13.8391 23.3315 14.8872 23.0673 15.636C23.184 15.8929 23.2381 16.2053 23.2074 16.5469L23.1957 16.5702V16.5936C23.0848 17.3278 22.8147 17.7745 22.4951 18.0183C22.3739 18.5233 22.1272 19.1612 21.7827 19.5714C21.7842 19.8925 21.7959 20.1815 21.8178 20.5523C22.0177 20.8705 22.6804 21.1274 23.3242 21.3814C24.4934 21.8412 26.0451 22.4645 26.6173 24.0789H28.3105C28.6842 24.0789 28.6842 23.7169 28.6842 23.7169C28.6857 20.8267 25.486 21.5113 25.0058 20.1903C24.9649 19.7495 24.959 19.7903 24.959 19.3495C25.159 19.2298 25.5269 18.5569 25.5663 17.9949C25.7269 17.9949 25.9648 17.83 26.0451 17.1891C26.0845 16.8695 25.9662 16.633 25.8465 16.5936C26.3282 15.9528 26.2494 13.4289 24.4452 13.4289L24.2 12.8684Z"
            fill="white"
          />
        </svg>
      ),
    },
  ];

  return (
    <div
      ref={divRef}
      className="offcanvas offcanvas-start offcanvas-detached rounded-m"
      id="menu-sidebar"
      data-menu-active="nav-welcome"
      style={{
        width: "288px",
        marginLeft: "20px",
        background: "#000000",
        height: "672px",
      }}
    >
      <button
        type="button"
        className="btn-close opacity-1"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        style={{ display: "none" }}
      ></button>
      <div className="p-2">
        <div
          className=""
          style={{
            background: "#16156B",
            borderRadius: "16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <div className="align-self-center me-auto">
            <p className="font-16 p-0 m-0" style={{ color: "#FFFFFF" }}>
              Welcome Back
            </p>
            <h1
              className="font-37 font-700 p-0 m-0"
              style={{ color: "#2C2AD1" }}
            >
              Mr Jackie
            </h1>
          </div>
          <div className="align-self-center ms-auto">
            <img
              src="images/pictures/25s.jpg"
              width="54"
              className="rounded-circle"
              alt="avatar"
            />
          </div>
        </div>

        <div
          className="divider divider-margins mb-3 mt-3"
          style={{
            height: "3px",
            background: "#1E1E1E",
            borderRadius: "50px",
          }}
        ></div>

        <div className="list-group list-custom list-menu-large">
          {links.map((item) => (
            <Link
              to={item.path}
              id="nav-welcome"
              className="list-group-item sidebar-button-click"
              onClick={handleClose}
            >
              {item.icons}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="font-16 font-400"
                  style={{
                    color: "#FFFFFF",
                    paddingLeft: "0px",
                  }}
                >
                  {item.title}
                </div>
                <svg
                  width="16"
                  height="9"
                  viewBox="0 0 16 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.7319 4.90909L10.6773 7.96364L11.4546 8.72728L15.8182 4.36363L11.4546 0L10.6773 0.763641L13.7319 3.81818H7.09097V4.90909H13.7319Z"
                    fill="#2C2AD1"
                  />
                  <path
                    d="M7.09097 3.81818H0V4.90909H7.09097V3.81818Z"
                    fill="#2C2AD1"
                  />
                </svg>
              </div>
            </Link>
          ))}
        </div>

        <h6 className="opacity-40 px-3 mt-4 font-14 font-400">Useful Links</h6>
        <div
          className="list-group list-custom list-menu-small"
          style={{ marginLeft: "12px" }}
        >
          <a
            href="tel:+1 234 567 8091"
            className="list-group-item default-link"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 11L11 7M11 7L7 11M11 7L11 15M1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11Z"
                stroke="#46403F"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div className="font-16 font-400 opacity-60">Support</div>
              <img
                src="./images/store/sidebar-rightarrow.png"
                alt="rightarrow"
              />
            </div>
          </a>
          <Link to="/account" className="list-group-item" onClick={handleClose}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.85 15.1C4.7 14.45 5.65 13.9375 6.7 13.5625C7.75 13.1875 8.85 13 10 13C11.15 13 12.25 13.1875 13.3 13.5625C14.35 13.9375 15.3 14.45 16.15 15.1C16.7333 14.4167 17.1875 13.6417 17.5125 12.775C17.8375 11.9083 18 10.9833 18 10C18 7.78333 17.2208 5.89583 15.6625 4.3375C14.1042 2.77917 12.2167 2 10 2C7.78333 2 5.89583 2.77917 4.3375 4.3375C2.77917 5.89583 2 7.78333 2 10C2 10.9833 2.1625 11.9083 2.4875 12.775C2.8125 13.6417 3.26667 14.4167 3.85 15.1ZM10 11C9.01667 11 8.1875 10.6625 7.5125 9.9875C6.8375 9.3125 6.5 8.48333 6.5 7.5C6.5 6.51667 6.8375 5.6875 7.5125 5.0125C8.1875 4.3375 9.01667 4 10 4C10.9833 4 11.8125 4.3375 12.4875 5.0125C13.1625 5.6875 13.5 6.51667 13.5 7.5C13.5 8.48333 13.1625 9.3125 12.4875 9.9875C11.8125 10.6625 10.9833 11 10 11ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
                fill="#46403F"
              />
            </svg>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div className="font-16 font-400 opacity-60">Account</div>
              <img
                src="./images/store/sidebar-rightarrow.png"
                alt="rightarrow"
              />
            </div>
          </Link>
          <Link to="/login" className="list-group-item" onClick={handleLogout}>
            <svg
              width="21"
              height="15"
              viewBox="0 0 21 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.6689 0.00498098C17.7481 0.00440875 17.7481 0.00440875 17.8288 0.00382497C17.8859 0.00383543 17.943 0.00387294 18.0001 0.0039355C18.0592 0.00377975 18.1183 0.00360624 18.1774 0.00341581C18.3011 0.00311792 18.4247 0.00312828 18.5483 0.00333948C18.7062 0.00357135 18.8641 0.00289353 19.022 0.00196496C19.144 0.00137346 19.266 0.00134049 19.388 0.00146508C19.4461 0.00144463 19.5043 0.00123666 19.5625 0.00083227C20.2016 -0.00306446 20.2016 -0.00306445 20.4766 0.23609C20.6046 0.386653 20.6067 0.499322 20.6069 0.690432C20.6071 0.73962 20.6072 0.788808 20.6074 0.839487C20.6074 0.894363 20.6073 0.949239 20.6073 1.00412C20.6074 1.06218 20.6075 1.12025 20.6076 1.17832C20.608 1.33829 20.608 1.49825 20.6081 1.65821C20.6081 1.83057 20.6084 2.00294 20.6087 2.1753C20.6093 2.55236 20.6095 2.92941 20.6097 3.30647C20.6098 3.54179 20.61 3.7771 20.6101 4.01242C20.6106 4.66363 20.611 5.31484 20.6112 5.96605C20.6112 6.02859 20.6112 6.02858 20.6112 6.09239C20.6112 6.15508 20.6112 6.15508 20.6112 6.21903C20.6112 6.30372 20.6113 6.38841 20.6113 6.4731C20.6113 6.51511 20.6113 6.55712 20.6113 6.60041C20.6115 7.28142 20.6122 7.96244 20.6131 8.64345C20.614 9.34222 20.6145 10.041 20.6146 10.7398C20.6146 11.1323 20.6149 11.5248 20.6156 11.9173C20.6162 12.2514 20.6164 12.5856 20.6161 12.9198C20.6159 13.0903 20.616 13.2609 20.6165 13.4314C20.617 13.5875 20.617 13.7436 20.6165 13.8996C20.6164 13.9562 20.6165 14.0127 20.6169 14.0692C20.6173 14.146 20.617 14.2227 20.6166 14.2994C20.6166 14.3421 20.6166 14.3847 20.6166 14.4287C20.5929 14.6108 20.5046 14.739 20.364 14.8539C20.1809 14.9884 20.0463 14.9891 19.8215 14.9904C19.7687 14.9908 19.716 14.9912 19.6616 14.9916C19.6041 14.9918 19.5466 14.9919 19.489 14.9921C19.4298 14.9923 19.3706 14.9925 19.3114 14.9928C19.1873 14.9932 19.0632 14.9934 18.9391 14.9936C18.7805 14.9938 18.622 14.9947 18.4635 14.9959C18.3412 14.9966 18.2189 14.9968 18.0965 14.9969C18.0381 14.997 17.9797 14.9973 17.9213 14.9979C17.2892 15.0032 17.2892 15.0032 17.0073 14.7713C16.8588 14.5889 16.8297 14.4095 16.8295 14.1786C16.8291 14.1058 16.8291 14.1058 16.8288 14.0315C16.8289 13.978 16.8291 13.9245 16.8292 13.871C16.8291 13.8138 16.829 13.7567 16.8288 13.6996C16.8284 13.5428 16.8284 13.386 16.8286 13.2292C16.8287 13.06 16.8284 12.8908 16.8281 12.7217C16.8275 12.3903 16.8275 12.059 16.8276 11.7276C16.8276 11.4583 16.8276 11.189 16.8274 10.9197C16.8274 10.8814 16.8273 10.8431 16.8273 10.8036C16.8273 10.7258 16.8272 10.6479 16.8272 10.5701C16.8267 9.83999 16.8268 9.10991 16.8271 8.37983C16.8273 7.71181 16.8268 7.0438 16.8261 6.37578C16.8253 5.68994 16.825 5.00411 16.8251 4.31826C16.8252 3.93319 16.8251 3.54811 16.8245 3.16303C16.824 2.83523 16.824 2.50743 16.8245 2.17963C16.8247 2.01238 16.8248 1.84513 16.8243 1.67788C16.8238 1.52475 16.824 1.37163 16.8245 1.21849C16.8246 1.16312 16.8245 1.10775 16.8242 1.05238C16.8223 0.705556 16.8258 0.459036 17.0523 0.183562C17.2424 0.0288133 17.4288 0.00593817 17.6689 0.00498098Z"
                fill="#46403F"
              />
              <path
                d="M12.3574 3.11766C12.4202 3.11765 12.4829 3.11759 12.5456 3.11748C12.6767 3.11743 12.8078 3.11793 12.9389 3.11884C13.1065 3.11998 13.2742 3.11987 13.4418 3.11936C13.5712 3.11908 13.7006 3.11939 13.83 3.11989C13.8918 3.12007 13.9536 3.12008 14.0154 3.11992C14.1019 3.11981 14.1883 3.12047 14.2748 3.12134C14.3239 3.12156 14.373 3.12177 14.4236 3.122C14.5985 3.14211 14.7338 3.19844 14.8644 3.31761C14.993 3.4828 15.0436 3.59369 15.0441 3.80103C15.0443 3.83885 15.0444 3.87667 15.0446 3.91564C15.0446 3.95727 15.0446 3.99891 15.0446 4.0418C15.0448 4.08597 15.0449 4.13013 15.0451 4.17564C15.0455 4.3244 15.0456 4.47316 15.0458 4.62193C15.046 4.72828 15.0463 4.83463 15.0466 4.94098C15.0474 5.26069 15.0478 5.5804 15.0481 5.90011C15.0483 6.05067 15.0485 6.20124 15.0487 6.3518C15.0494 6.85233 15.05 7.35285 15.0503 7.85338C15.0504 7.98327 15.0504 8.11316 15.0505 8.24305C15.0505 8.27534 15.0506 8.30762 15.0506 8.34088C15.0509 8.86382 15.0519 9.38676 15.0532 9.9097C15.0546 10.4466 15.0553 10.9835 15.0554 11.5204C15.0555 11.8219 15.0558 12.1233 15.0569 12.4248C15.0577 12.6815 15.0581 12.9382 15.0577 13.195C15.0575 13.3259 15.0576 13.4569 15.0583 13.5878C15.059 13.7299 15.0588 13.872 15.0582 14.0141C15.0587 14.0553 15.0591 14.0965 15.0596 14.1389C15.0574 14.3849 15.0253 14.5807 14.8786 14.7837C14.6591 14.9621 14.495 14.9886 14.2185 14.9903C14.1658 14.9907 14.113 14.991 14.0586 14.9914C14.0011 14.9916 13.9436 14.9918 13.8861 14.992C13.8269 14.9922 13.7676 14.9924 13.7084 14.9926C13.5843 14.9931 13.4602 14.9933 13.3361 14.9934C13.1776 14.9937 13.0191 14.9946 12.8605 14.9958C12.7382 14.9965 12.6159 14.9967 12.4935 14.9968C12.4351 14.9969 12.3767 14.9972 12.3183 14.9977C11.675 15.0031 11.675 15.0031 11.4471 14.8023C11.3289 14.643 11.2718 14.5601 11.2713 14.3633C11.2711 14.306 11.2711 14.306 11.2708 14.2476C11.2708 14.2053 11.2708 14.1631 11.2708 14.1195C11.2707 14.0749 11.2705 14.0302 11.2704 13.9842C11.2699 13.8336 11.2698 13.683 11.2696 13.5323C11.2694 13.4247 11.2691 13.3171 11.2688 13.2095C11.268 12.8859 11.2676 12.5622 11.2673 12.2386C11.2671 12.0862 11.2669 11.9339 11.2667 11.7815C11.266 11.2751 11.2654 10.7687 11.2651 10.2622C11.2651 10.1308 11.265 9.99929 11.2649 9.86783C11.2649 9.83515 11.2649 9.80247 11.2648 9.76881C11.2645 9.2395 11.2635 8.71019 11.2622 8.18088C11.2609 7.6376 11.2601 7.09431 11.26 6.55102C11.2599 6.24593 11.2596 5.94084 11.2586 5.63575C11.2577 5.37591 11.2574 5.11607 11.2578 4.85623C11.2579 4.72366 11.2578 4.59111 11.2571 4.45855C11.2564 4.31476 11.2567 4.171 11.2572 4.0272C11.2568 3.98541 11.2563 3.94361 11.2559 3.90055C11.2581 3.65074 11.2889 3.50119 11.4368 3.2976C11.6971 3.06979 12.0301 3.11502 12.3574 3.11766Z"
                fill="#46403F"
              />
              <path
                d="M6.45309 6.53267C6.4792 6.53247 6.50531 6.53228 6.53222 6.53207C6.61857 6.53149 6.70492 6.53121 6.79128 6.53099C6.85145 6.53076 6.91162 6.53053 6.9718 6.5303C7.09803 6.52988 7.22425 6.52965 7.35048 6.52951C7.51174 6.52929 7.67299 6.52833 7.83425 6.52719C7.95861 6.52644 8.08297 6.52623 8.20733 6.52617C8.26675 6.52605 8.32617 6.52573 8.38558 6.5252C8.469 6.52452 8.55239 6.5246 8.63582 6.52486C8.68318 6.52471 8.73054 6.52456 8.77934 6.52441C8.96287 6.54423 9.12408 6.59609 9.26541 6.72062C9.41371 6.92057 9.44176 7.03011 9.4417 7.27453C9.44185 7.30531 9.442 7.3361 9.44215 7.36782C9.44259 7.47154 9.44274 7.57526 9.4429 7.67899C9.44315 7.75313 9.44341 7.82727 9.44369 7.90142C9.44439 8.10327 9.44481 8.30511 9.44514 8.50696C9.44535 8.63301 9.44559 8.75906 9.44584 8.88511C9.4466 9.27932 9.44717 9.67354 9.44751 10.0677C9.4479 10.5231 9.44895 10.9785 9.45057 11.4338C9.45178 11.7856 9.45237 12.1373 9.4525 12.4891C9.4526 12.6993 9.45296 12.9094 9.45396 13.1196C9.45489 13.3174 9.45506 13.5151 9.45465 13.7129C9.45463 13.7854 9.45488 13.858 9.45543 13.9306C9.45614 14.0297 9.45586 14.1288 9.45533 14.2279C9.45577 14.2566 9.45621 14.2852 9.45666 14.3148C9.45408 14.5158 9.40042 14.628 9.27573 14.7835C9.07226 14.9717 8.92784 14.9885 8.65629 14.9901C8.60366 14.9905 8.55102 14.9908 8.49678 14.9912C8.43939 14.9914 8.38199 14.9916 8.32459 14.9917C8.26547 14.992 8.20635 14.9922 8.14723 14.9924C8.02329 14.9929 7.89935 14.9931 7.77542 14.9932C7.61726 14.9935 7.45911 14.9944 7.30095 14.9956C7.17879 14.9963 7.05663 14.9965 6.93446 14.9966C6.87619 14.9967 6.81792 14.997 6.75965 14.9975C6.18614 15.0024 6.18614 15.0024 5.91394 14.8636C5.73191 14.6815 5.66527 14.5014 5.66273 14.2452C5.66292 14.2032 5.66292 14.2032 5.66311 14.1604C5.66292 14.1302 5.66274 14.1 5.66256 14.0689C5.66205 13.9679 5.66211 13.867 5.66218 13.766C5.66194 13.6936 5.66167 13.6211 5.66137 13.5487C5.66066 13.352 5.66047 13.1552 5.66042 12.9585C5.66036 12.8356 5.66019 12.7126 5.65998 12.5897C5.65924 12.1606 5.65891 11.7316 5.65898 11.3025C5.65902 10.9028 5.65818 10.5031 5.65692 10.1034C5.65587 9.76 5.65544 9.41665 5.65549 9.07329C5.65551 8.86829 5.65528 8.66331 5.65444 8.45831C5.65366 8.26545 5.65365 8.07261 5.65424 7.87974C5.65432 7.80908 5.65413 7.73842 5.65365 7.66776C5.64936 6.99874 5.64936 6.99874 5.83389 6.73923C6.04103 6.57437 6.19273 6.53418 6.45309 6.53267Z"
                fill="#46403F"
              />
              <path
                d="M0.833969 9.32422C0.861205 9.32388 0.888441 9.32354 0.916502 9.32319C1.00592 9.32226 1.0953 9.32222 1.18472 9.32227C1.24732 9.32198 1.30992 9.32167 1.37251 9.32134C1.50351 9.32081 1.6345 9.32074 1.7655 9.32098C1.93273 9.32121 2.09992 9.31999 2.26714 9.31837C2.39638 9.31733 2.52561 9.31722 2.65486 9.31737C2.71648 9.3173 2.7781 9.31692 2.83971 9.3162C3.47241 9.30966 3.47241 9.30966 3.71263 9.54113C3.8446 9.71567 3.87756 9.87513 3.87834 10.0904C3.87857 10.1282 3.87879 10.1661 3.87903 10.2051C3.8791 10.267 3.8791 10.267 3.87917 10.3302C3.87946 10.3957 3.87946 10.3957 3.87977 10.4626C3.88035 10.6072 3.88063 10.7518 3.88085 10.8964C3.88108 10.9969 3.88131 11.0974 3.88154 11.1979C3.8819 11.3817 3.88216 11.5655 3.88228 11.7494C3.88246 12.0195 3.88316 12.2897 3.88432 12.5598C3.88529 12.7942 3.8856 13.0285 3.88567 13.2629C3.88579 13.3624 3.88611 13.462 3.88663 13.5615C3.88732 13.7008 3.88724 13.84 3.88698 13.9793C3.88735 14.0204 3.88772 14.0614 3.8881 14.1037C3.88641 14.3933 3.84862 14.5872 3.6601 14.8164C3.46998 14.9712 3.28358 14.9941 3.04346 14.995C2.96431 14.9956 2.96431 14.9956 2.88357 14.9962C2.82647 14.9962 2.76936 14.9961 2.71226 14.9961C2.65315 14.9962 2.59405 14.9964 2.53494 14.9966C2.41131 14.9969 2.28769 14.9969 2.16406 14.9967C2.00617 14.9964 1.84829 14.9971 1.6904 14.998C1.56841 14.9986 1.44642 14.9987 1.32443 14.9985C1.26624 14.9986 1.20805 14.9988 1.14986 14.9992C0.518494 15.003 0.518494 15.003 0.287934 14.8118C0.111654 14.6338 0.0823661 14.4916 0.0786133 14.2448C0.0791622 14.2009 0.0797112 14.1571 0.0802768 14.1119C0.0799203 14.0651 0.0795638 14.0183 0.0791965 13.97C0.0783455 13.8157 0.0792372 13.6614 0.0802279 13.507C0.0801678 13.3995 0.0800327 13.292 0.0798194 13.1845C0.079566 12.9594 0.0802945 12.7342 0.0816056 12.5091C0.083106 12.2493 0.0830349 11.9896 0.0821242 11.7298C0.081284 11.4792 0.081578 11.2287 0.0823771 10.9781C0.082611 10.8718 0.0825594 10.7655 0.082216 10.6591C0.0818958 10.5104 0.0828675 10.3618 0.0841851 10.2131C0.0836718 10.1474 0.0836718 10.1474 0.0831482 10.0803C0.086602 9.85419 0.102234 9.69073 0.252357 9.51478C0.430067 9.35157 0.599467 9.32583 0.833969 9.32422Z"
                fill="#46403F"
              />
            </svg>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div className="font-16 font-400 opacity-60">Log Out</div>
              <img
                src="./images/store/sidebar-rightarrow.png"
                alt="rightarrow"
              />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};
